import { Outlet } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import { DashboardPage } from 'src/pages/dashboard';
import { RouteProps } from 'src/types/router';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <DashboardPage />,
    accessRoles: [BusinessRole.PlatformAdmin],
  },
];

export const DASHBOARD_ROUTE: RouteProps = {
  path: appRoutes.dashboard.index,
  element: <Outlet />,
  childRoutes: ROUTES,
  accessRoles: [ReactRouteAccessKey.anyAuthorized],
};
